import React from "react";
import styled from "@emotion/styled";
import { BaseRecipe } from "../../types/BaseRecipe";
import { EnergyRating } from "../../types/MealPlan";
import { default as colors } from "../../utils/colors.json";
import { formatCarbsValue } from "../../utils/nutrition";
import Nutrition from "../Nutrition/Nutrition";

const BadgeContainer = styled.div`
  background-color: ${({ energyRating }: { energyRating: EnergyRating }) => getColorForCarbs(energyRating)};
  border-radius: 50%;
  color: ${colors.WHITE};
  height: 35px;
  width: 35px;
  font-size: 14px;
  font-weight: 700;
  line-height: 35px;
  text-align: center;
`;

export const getColorForCarbs = (energyRating: EnergyRating) => {
  switch (energyRating) {
    case "strict":
    case "keto":
      return colors.KETO;
    case "moderate":
      return colors.MODERATE;
    default:
      return colors.LIBERAL;
  }
};

const CarbsBadge = ({ recipe, className }: { recipe: BaseRecipe; className?: string }) => {
  if (!recipe.nutrition.values.carbs) {
    return null;
  }
  const carbs = formatCarbsValue(recipe.nutrition.values.carbs);
  const strictness = recipe.strictness.rating as EnergyRating;
  const isHighProtein = recipe.isHighProtein;

  return (
    <Nutrition
      id={recipe.id}
      nutrition={recipe.nutrition}
      strictness={strictness}
      className={className}
      isHighProtein={isHighProtein}
    >
      <div className={isHighProtein ? "p-1 bg-light-blue rounded-3xl" : ""}>
        <div className={isHighProtein ? "p-0.5 bg-white rounded-3xl" : ""}>
          <BadgeContainer energyRating={strictness}>{carbs}g</BadgeContainer>
        </div>
      </div>
    </Nutrition>
  );
};

export default CarbsBadge;
